import {NgModule} from '@angular/core';

import {LayoutRoutingModule} from './layout-routing.module';
import {ResourcesModule} from '../resource/resources.module';
import {LayoutService} from './layout.service';
import {DialogsModule} from '../shared/dialog/dialogs.module';
import {TimeAgoModule} from '../shared/component/smd-timeline/TimeAgoModule';
import {CanDeactivateGuard} from '../resource/detail/controls/canDeactivateGuard/canDeactivateGuard';

@NgModule({
  imports: [LayoutRoutingModule, ResourcesModule, DialogsModule, TimeAgoModule],
  declarations: [],
  providers: [LayoutService, CanDeactivateGuard],
})
export class LayoutModule {}
